import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from "@angular/forms";
import { ColumnComponent, GridComponent, RowArgs, ScrollRequest } from "@progress/kendo-angular-grid";
import { State } from "@progress/kendo-data-query/dist/npm/state";
import { Moment } from "jalali-moment";

import * as moment from "jalali-moment";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { DetailLedger, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { GridColumnInfo, GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import {
  AccountService,
  GridFilter,
  HttpCommonService,
  isNullOrUndefined,
  isNumber,
  LookupService,
  PagingDataResult,
  ShowToastrService,
} from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ChequeBookDetail } from "../../models/cheque-book-Header.model";
import { TrsReferenceVoucherByVoucherKindFilterInfo } from "../../models/trs-reference-voucher-byvoucher-kindfilterinfo";
import { TrsVoucherDetail } from "../../models/trs-voucher-detail.model";
import { TrsVoucherKind } from "../../models/trs-voucher-kind.model";

@Component({
  selector: "trs-voucher-detail",
  templateUrl: "./trs-voucher-detail.component.html",
  styleUrls: ["./trs-voucher-detail.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrsVoucherDetailComponent implements OnInit {
  dataReadedColumns: string = "";
  LookupData: Dictionary = [];
  DefaultValues: Dictionary = [];
  _GridColumnInfo: GridColumnInfo;
  isFirstLoad: boolean;
  @ViewChild("grid") public grid: GridComponent;
  currentLookup: any;
  public isNew: boolean;
  public mySelection: number[] = [];
  isDisabled: boolean = false;
  groupsName = "VoucherNo";
  isLOading: boolean = false;
  treferenceVoucherLoded: boolean = false;
  ngUnsubscribe = new Subject<void>();
  @Input() headerTitleToDetailTitle: string;
  @Output() valueChanges = new EventEmitter<any>();
  @Input() RowNumberName: string;
  @Input() columns: form_control[] = [];
  @Input() isAdd: boolean = true;
  @Input() isEdit: boolean = false;
  @Input() isDelete: boolean = true;
  @Input() isPriceable: boolean = false;
  @Input() hasDiscount: boolean = false;
  @Input() hasReference: boolean = false;
  @Input() hasReferenceRequired: boolean = false;
  @Input() IsPurchaseTrsoice: boolean = false;
  @Input() IsReturnPurchaseTrsoice: boolean = false;
  _filterEntity: TrsReferenceVoucherByVoucherKindFilterInfo;
  @Input() get filterEntity(): TrsReferenceVoucherByVoucherKindFilterInfo {
    return this._filterEntity;
  }
  get detailLedgerLevel(): number {
    return this.missetup.getnumber("ACC", "DLLEVEL");
  }
  set filterEntity(value: TrsReferenceVoucherByVoucherKindFilterInfo) {
    if (
      !this._filterEntity ||
      this._filterEntity.BranchId !== value.BranchId ||
      this._filterEntity.FiscalYearId !== value.FiscalYearId ||
      this._filterEntity.DetailLedgerId !== value.DetailLedgerId ||
      this._filterEntity.ReferencedVoucherKindId !== value.ReferencedVoucherKindId ||
      this._filterEntity.VoucherKindId !== value.VoucherKindId ||
      new Date(this._filterEntity.VoucherDate).setHours(0, 0, 0, 0) !== new Date(value.VoucherDate).setHours(0, 0, 0, 0) ||
      this._filterEntity.TreasuryDetailLedgerId !== value.TreasuryDetailLedgerId ||
      this._filterEntity.DurationKindCode !== value.DurationKindCode
    ) {
      this.treferenceVoucherLoded = false;
      this._filterEntity = value;
      this.setreferenceVoucherByVoucherKindList("TrsVoucherHeader/GeTreferenceVoucherByVoucherKind");
    }
    this._filterEntity = value;
  }
  public isRowSelected = (e: RowArgs) => this.mySelection.indexOf(e.dataItem.RowNumber) >= 0;

  _ReferenceVoucherKindId: number;
  @Input() get ReferenceVoucherKindId(): number {
    return this._ReferenceVoucherKindId;
  }
  set ReferenceVoucherKindId(value: number) {
    this._ReferenceVoucherKindId = value;
    this.setColumns();
  }
  @Input() CurrentVoucherKind: TrsVoucherKind;
  public formGroup: UntypedFormGroup;
  _dataList: TrsVoucherDetail[];
  loadingData: boolean = false;
  @Input()
  get dataList(): TrsVoucherDetail[] {
    return this._dataList;
  }
  set dataList(value: TrsVoucherDetail[]) {
    this._dataList = value;
    let filterddata = this._dataList?.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.gridData = filterddata?.sort((a, b) => a.RowNumber - b.RowNumber);
  }
  gridData: TrsVoucherDetail[];
  rowIsEditing: boolean = false;
  CurrentReferenceVoucherKind: TrsVoucherKind;
  editedRow: any;
  editedRowIndex: number = 0;
  public state: State = {
    skip: 0,
    take: 5,
    filter: {
      logic: "and",
      filters: [],
    },
    group: [],
  };

  getGridCell(index) {
    return this.grid.columns.toArray()[index];
  }
  getColumnIndex(colIndex: number) {
    let index: number = -1;
    let ColumnName: string;
    this.grid.columns
      .toArray()
      .filter((x) => x.isVisible)
      .forEach((x) => {
        index = index + 1;
        if (index == colIndex) ColumnName = x["field"];
      });
    return ColumnName;
  }
  DetailControlModels: Dictionary;
  @HostListener("window:keydown", ["$event"])
  cArrowDown(e: KeyboardEvent) {
    if (document.hidden) return;
    if (e.altKey && e.shiftKey && (e.key === "n" || e.key === "N" || e.key === "أ")) {
      e.preventDefault();
      this.addHandler();
    }
    if (e.ctrlKey && e.altKey && (e.key === "s" || e.key === "S" || e.key === "س")) {
      e.preventDefault();
      this.saveCurrent();
    }
    if (e.ctrlKey && (e.key === "c" || e.key === "C" || e.key === "ز")) {
      e.preventDefault();
      this.copyHandler();
    }
    if (e.ctrlKey && (e.key === "v" || e.key === "V" || e.key === "ر")) {
      e.preventDefault();
      this.pasetHandler();
    }
    if (e.key === "Tab" && !e.shiftKey) {
      if (this.formGroup && this.grid.activeCell) {
        if (this.formGroup?.valid && this.getColumnIndex(this.grid.activeCell.colIndex) === "Comment") {
          this.saveCurrent();
          e.preventDefault();
          if (this.grid.activeCell.rowIndex < this.dataList.length) {
            this.editedRowIndex = this.grid.activeCell.rowIndex;
            this.cd.markForCheck();
            if (this.editedRowIndex < this.dataList.length) this.setFormGroup(this.dataList[this.editedRowIndex]);
            else this.setFormGroup(this.dataList[this.dataList.length - 1]);
            if (this.grid) {
              this.grid.editRow(this.editedRowIndex, this.formGroup);
            }
          } else
            setTimeout(() => {
              this.addHandler();
            }, 200);
        }
      }
    }
    if (e.key.toUpperCase() === "F4") {
      e.preventDefault();
      if (this.dataList.length > 1 && this.formGroup.controls["RowNumber"].value > 1) {
        let ColumnName = this.getColumnIndex(this.grid.activeCell.colIndex);
        if (ColumnName.includes("SubLedger") || ColumnName.includes("DetailLedger") || ColumnName.includes("Concern")) {
          let PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2][ColumnName];
          this.formGroup.controls[ColumnName].setValue(PrevValue);
          PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2][ColumnName.replace("Id", "Code")];
          this.formGroup.controls[ColumnName.replace("Id", "Code")].setValue(PrevValue);
          PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2][ColumnName.replace("Id", "Title")];
          this.formGroup.controls[ColumnName.replace("Id", "Title")].setValue(PrevValue);
        } else {
          let PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2][ColumnName];
          this.formGroup.controls[ColumnName].setValue(PrevValue);
          if (this.grid.activeRow.dataItem) this.grid.activeRow.dataItem[ColumnName] = PrevValue;
        }
        this.selectorService.onSubmited.next(true);
        this.cd.markForCheck();
      }
    }
    if (e.key.toUpperCase() === "F5") {
      e.preventDefault();
      if (!this.formGroup || !this.gridData || this.gridData.length < 2) return;
      Object.keys(this.dataList[0])
        .filter((x) => x !== "RowNumber" && x !== "Id" && x !== "State")
        .forEach((key) => {
          if (key && this.formGroup.controls[key]) {
            let PrevValue = this.gridData[this.formGroup.controls["RowNumber"].value - 2][key];
            this.formGroup.controls[key].setValue(PrevValue);
            if (this.grid.activeRow.dataItem) this.grid.activeRow.dataItem[key] = PrevValue;
          }
        });
      this.cd.markForCheck();
    }
    if (this.formGroup && e.ctrlKey && e.key.toUpperCase() === "DELETE") {
      e.preventDefault();
      this.removeHandler({ sender: this.grid, dataItem: this.formGroup.value });
    }
  }
  constructor(
    private lookupservice: LookupService,
    private sts: ShowToastrService,
    private cd: ChangeDetectorRef,
    private missetup: MisSetupService,
    protected selectorService: SelectorService,
    private accountService: AccountService,
    private _httpCommonService: HttpCommonService
  ) {
    this.onDataStateChange = this.onDataStateChange.bind(this);
    this.shouldBeChangedData = this.shouldBeChangedData.bind(this);
  }
  getColumns() {
    return this.selectorService.getColumns("ReferenceId");
  }
  ngOnInit(): void {
    this.DefaultValues["Price"] = 0;
    this.DefaultValues["DiscountRate"] = 0;
    this.DefaultValues["DiscountAmount"] = 0;
    this.DefaultValues["TrsVoucherHeaderId"] = 0;
    if (!this.dataList) this.dataList = [];
    this.setColumns();

    if (
      !this.ReferenceVoucherKindId &&
      this.CurrentVoucherKind &&
      this.CurrentVoucherKind.TrsReferenceVoucherKinds &&
      this.CurrentVoucherKind.TrsReferenceVoucherKinds.length > 0
    ) {
      let vk = this.CurrentVoucherKind.TrsReferenceVoucherKinds.find((vk) => vk.IsDefault);
      if (vk) this.ReferenceVoucherKindId = vk.ReferenceVoucherKindId;
    }
    if (!this.CurrentReferenceVoucherKind && this.ReferenceVoucherKindId) this.fillCollectionsKind(this.ReferenceVoucherKindId);

    setTimeout(() => {
      if (this.dataList.length <= 0) this.addHandler();
    }, 50);
  }
  setColumns() {
    this.setColumnWith();
    if (this.CurrentVoucherKind) {
      this.columns.forEach((x) => {
        if (x.name === "BankId") {
          x.listVisible = this.CurrentVoucherKind.ShowBank || this.CurrentVoucherKind.DocumentKindCode === 1;
          x.required = x.listVisible && this.CurrentVoucherKind.RequireBank;
          if (!isNullOrUndefined(this.CurrentVoucherKind.BankCaption)) x.label = this.CurrentVoucherKind.BankCaption;
        }
        if (x.name === "SubLedgerId") x.listVisible = this.CurrentVoucherKind.ShowSubLedger && !this.CurrentVoucherKind.SubledgerInHeader;

        if (x.name === "ConcernId") {
          x.listVisible = !this.CurrentVoucherKind.ConcernInHeader;
          x.required = x.listVisible && x.listVisible;
        }

        if (x.name === "DetailLedgerId") {
          x.listVisible = !this.CurrentVoucherKind.DetailLedgerInHeader;
          x.required = x.listVisible && this.CurrentVoucherKind.RequireDetailLedger && !this.CurrentVoucherKind.DetailLedgerInHeader;
          if (!isNullOrUndefined(this.CurrentVoucherKind.DetailLedgerCaption)) x.label = this.CurrentVoucherKind.DetailLedgerCaption;
        }

        if (x.name === "TreasuryDetailLedgerId") {
          x.listVisible = !this.CurrentVoucherKind.TreasuryDetailLedgerInHeader && this.CurrentVoucherKind?.ShowTreasuryDetailLedger === true;
          x.required = x.listVisible && !this.CurrentVoucherKind.TreasuryDetailLedgerInHeader && this.CurrentVoucherKind.RequireTreasuryDetailLedger;
          if (!isNullOrUndefined(this.CurrentVoucherKind.TreasuryDetailLedgerCaption)) x.label = this.CurrentVoucherKind.TreasuryDetailLedgerCaption;
        }
        if (x.name.includes("DetailLedger1Id")) {
          x.listVisible = this.detailLedgerLevel >= 1;
        }
        if (x.name.includes("DetailLedger2Id")) {
          x.listVisible = this.detailLedgerLevel >= 2;
        }
        if (x.name.includes("DetailLedger3Id")) {
          x.listVisible = this.detailLedgerLevel >= 3;
        }
        if (x.name.includes("DetailLedger4Id")) {
          x.listVisible = this.detailLedgerLevel >= 4;
        }
        if (x.name.includes("DetailLedger5Id")) {
          x.listVisible = this.detailLedgerLevel >= 5;
        }
        if (x.name.includes("DetailLedger6Id")) {
          x.listVisible = this.detailLedgerLevel >= 6;
        }
        if (x.name.includes("DetailLedger7Id")) {
          x.listVisible = this.detailLedgerLevel >= 7;
        }

        if (x.name.includes("TreasuryDetailLedger1Id")) {
          x.listVisible = this.detailLedgerLevel >= 1;
        }
        if (x.name.includes("TreasuryDetailLedger2Id")) {
          x.listVisible = this.detailLedgerLevel >= 2;
        }
        if (x.name.includes("TreasuryDetailLedger3Id")) {
          x.listVisible = this.detailLedgerLevel >= 3;
        }
        if (x.name.includes("TreasuryDetailLedger4Id")) {
          x.listVisible = this.detailLedgerLevel >= 4;
        }
        if (x.name.includes("TreasuryDetailLedger5Id")) {
          x.listVisible = this.detailLedgerLevel >= 5;
        }
        if (x.name.includes("TreasuryDetailLedger6Id")) {
          x.listVisible = this.detailLedgerLevel >= 6;
        }
        if (x.name.includes("TreasuryDetailLedger7Id")) {
          x.listVisible = this.detailLedgerLevel >= 7;
        }

        if (x.name === "BankAccountId") {
          x.listVisible =
            ((this.CurrentVoucherKind?.DocumentKindCode === 1 || this.CurrentVoucherKind?.DocumentKindCode === 3) ||
            (this.CurrentVoucherKind?.OperationKindCode === 5 && this.CurrentVoucherKind?.EffectKindCode === 3) ||
            (this.CurrentVoucherKind?.OperationKindCode === 6 && (this.CurrentVoucherKind?.EffectKindCode === 2)) ||
            (this.CurrentVoucherKind?.OperationKindCode === 7 && this.CurrentVoucherKind?.EffectKindCode === 2));
        }
        if (x.name === "ChequeId") {
          if (
            this.CurrentVoucherKind.IsCheckBook &&
            this.CurrentVoucherKind.DocumentKindCode === 1 &&
            this.CurrentVoucherKind.ShowDocumentNo 
            && !this.CurrentVoucherKind.Guarantee
          )
            x.listVisible = this.CurrentVoucherKind.IsCheckBook;

          if (!isNullOrUndefined(this.CurrentVoucherKind.DocumentNoCaption)) x.label = this.CurrentVoucherKind.DocumentNoCaption;
          x.required = x.listVisible && this.CurrentVoucherKind.RequireDocumentNo;
        }
        if (x.name === "DocumentNo") {
          x.listVisible = this.CurrentVoucherKind.ShowDocumentNo && !this.CurrentVoucherKind.IsCheckBook;
          if (!isNullOrUndefined(this.CurrentVoucherKind.DocumentNoCaption)) x.label = this.CurrentVoucherKind.DocumentNoCaption;
          x.required = x.listVisible && x.listVisible && this.CurrentVoucherKind.RequireDocumentNo;
          
        }
        if (x.name === "DocumentDate") {
          x.listVisible = this.CurrentVoucherKind.ShowDocumentNo;
          if (!isNullOrUndefined(this.CurrentVoucherKind.DocumentDateCaption)) x.label = this.CurrentVoucherKind.DocumentDateCaption;
          x.required = x.listVisible && x.listVisible && this.CurrentVoucherKind.RequireDocumentNo;
        }

        if (x.name === "BankAccountNo")
          x.listVisible =
            this.CurrentVoucherKind?.DocumentKindCode === 1 &&
            (this.CurrentVoucherKind?.OperationKindCode === 1 ||
              this.CurrentVoucherKind?.OperationKindCode === 3 ||
              this.CurrentVoucherKind?.OperationKindCode === 4 ||
              (this.CurrentVoucherKind?.OperationKindCode === 5 && this.CurrentVoucherKind?.EffectKindCode === 2) ||
              (this.CurrentVoucherKind?.OperationKindCode === 6 && this.CurrentVoucherKind?.EffectKindCode === 3) ||
              (this.CurrentVoucherKind?.OperationKindCode === 7 && this.CurrentVoucherKind?.EffectKindCode === 3));
        if (x.name === "BankBranchCode") {
          x.listVisible = this.CurrentVoucherKind.ShowBranchCode;
          if (!isNullOrUndefined(this.CurrentVoucherKind.BranchCodeCaption)) x.required = x.listVisible && this.CurrentVoucherKind.RequireBranchCode;
          else x.required = false;
        }
        if (x.name === "BankBranchTitle") {
          x.listVisible = this.CurrentVoucherKind.ShowBranchCode;
          if (!isNullOrUndefined(this.CurrentVoucherKind.BranchTitleCaption)) x.label = this.CurrentVoucherKind.BranchTitleCaption;
          x.required = x.listVisible && this.CurrentVoucherKind.RequireBranchCode;
        }
        if (x.name === "Tag1") {
          x.listVisible = this.CurrentVoucherKind.ShowTag1;
          if (!isNullOrUndefined(this.CurrentVoucherKind.TagCaption1)) x.label = this.CurrentVoucherKind.TagCaption1;
          x.required = x.listVisible && this.CurrentVoucherKind.RequireTag1;
        }
        if (x.name === "Tag2") {
          x.listVisible = this.CurrentVoucherKind.ShowTag2;
          if (!isNullOrUndefined(this.CurrentVoucherKind.TagCaption2)) x.label = this.CurrentVoucherKind.TagCaption2;
          x.required = x.listVisible && this.CurrentVoucherKind.RequireTag2;
        }
        if (x.name === "Tag3") {
          x.listVisible = this.CurrentVoucherKind.ShowTag3;
          if (!isNullOrUndefined(this.CurrentVoucherKind.TagCaption3)) x.label = this.CurrentVoucherKind.TagCaption3;
          x.required = x.listVisible && this.CurrentVoucherKind.RequireTag3;
        }
        if (x.name === "Tag4") {
          x.listVisible = this.CurrentVoucherKind.ShowTag4;
          if (!isNullOrUndefined(this.CurrentVoucherKind.TagCaption4)) x.label = this.CurrentVoucherKind.TagCaption4;
          x.required = x.listVisible && this.CurrentVoucherKind.RequireTag4;
        }
        if (x.name === "Tag5") {
          x.listVisible = this.CurrentVoucherKind.ShowTag5;
          if (!isNullOrUndefined(this.CurrentVoucherKind.TagCaption5)) x.label = this.CurrentVoucherKind.TagCaption5;
          x.required = x.listVisible && this.CurrentVoucherKind.RequireTag5;
        }
        if (x.name === "Tag6") {
          x.listVisible = this.CurrentVoucherKind.ShowTag6;
          if (!isNullOrUndefined(this.CurrentVoucherKind.TagCaption6)) x.label = this.CurrentVoucherKind.TagCaption6;
          x.required = x.listVisible && this.CurrentVoucherKind.RequireTag6;
        }
        if (x.name === "ReferenceId") {
          x.listVisible = this.hasReference && !isNullOrUndefined(this.ReferenceVoucherKindId);
          x.required = x.listVisible && this.hasReference && this.hasReferenceRequired && !isNullOrUndefined(this.ReferenceVoucherKindId);
        }
      });
    }
    if (this.CurrentVoucherKind) {
      this.columns.forEach((x) => {
        if (x.listVisible && x.apiName) {
          if (
            !(x.name === "ConcernId" && this.CurrentVoucherKind.ConcernInHeader) &&
            !(x.name === "DetailLedgerId" && this.CurrentVoucherKind.DetailLedgerInHeader) &&
            !(x.name === "TreasuryDetailLedgerId" && this.CurrentVoucherKind.TreasuryDetailLedgerInHeader) &&
            !(x.name === "SubLedgerId" && this.CurrentVoucherKind.SubledgerInHeader)
          )
            this.setDropdownlist(x.apiName, x.systemName, x.category);
        }
      });
    }
  }
  setFormGroup(entity: any = null) {
    let group: any = {};
    +"";
    this.columns.forEach((question) => {
      switch (question.textType) {
        case "text":
          {
            let validator: ValidatorFn[] = [];
            if (question.required) validator.push(Validators.required);
            if (question.minLength && question.minLength > 0) validator.push(Validators.minLength(question.minLength));
            if (question.maxLength && question.maxLength > 0) validator.push(Validators.maxLength(question.maxLength));
            if (question.max && question.max > 0) validator.push(Validators.max(question.max));
            if (question.min && question.min > 0) validator.push(Validators.min(question.min));

            group[question.name] = question.required
              ? new UntypedFormControl(!entity ? null : entity[question.name] || null, validator)
              : new UntypedFormControl(!entity ? null : entity[question.name] || null);
          }
          break;
        case "checkbox":
          group[question.name] = question.required
            ? new UntypedFormControl(!entity ? false : entity[question.name] || false, Validators.required)
            : new UntypedFormControl(!entity ? false : entity[question.name] || false);
          break;
        case "number":
          {
            let validator: ValidatorFn[] = [];
            if (question.required) validator.push(Validators.required);
            if (question.max && question.max > 0) validator.push(Validators.max(question.max));
            if (question.min && question.min > 0) validator.push(Validators.min(question.min));

            group[question.name] = question.required
              ? new UntypedFormControl(!entity ? null : entity[question.name] || null, validator)
              : new UntypedFormControl(!entity ? this.DefaultValues[question.name] : entity[question.name] || this.DefaultValues[question.name]);
          }
          break;
        case "date":
          group[question.name] = question.required
            ? new UntypedFormControl(!entity[question.name] && question.required ? new Date() : entity[question.name], Validators.required)
            : new UntypedFormControl(!entity[question.name] && question.required ? new Date() : entity[question.name]);
          break;
        default:
          group[question.name] = question.required
            ? new UntypedFormControl(!entity ? null : entity[question.name] || null, Validators.required)
            : new UntypedFormControl(!entity ? null : entity[question.name] || null);
          break;
      }
    });

    group["TrsVoucherHeaderId"] = new UntypedFormControl(!entity ? 0 : entity["TrsVoucherHeaderId"] || 0);
    group["State"] = new UntypedFormControl(!entity ? RowState.New : entity["State"] || RowState.NoChange);
    group["Id"] = new UntypedFormControl(!entity ? 0 : entity["Id"] || 0);
    group["RowVersion"] = new UntypedFormControl(!entity ? "" : entity["RowVersion"] || "");

    if (this.RowNumberName) group[this.RowNumberName] = new UntypedFormControl(!entity ? this.gridData.length + 1 : entity[this.RowNumberName] || 0);
    this.formGroup = new UntypedFormGroup(group);
    this.setChanges();
  }
  setColumnWith() {
    this.columns.forEach((x) => {
      if (
        x.textType === "number" &&
        x.withComma &&
        !x.name.toUpperCase().includes("NUMBER") &&
        !x.name.toUpperCase().includes("CODE") &&
        !x.name.toUpperCase().includes(".ID")
      )
        x.format = "#,#.#####";
      else x.format = x.textType === "number" ? "#" : "";
      if (!x.columnWidth || x.columnWidth < 100) {
        if (x.textType === "text") x.columnWidth = 200;
        else x.columnWidth = 100;
      }
      if (x.name === "BranchTitle") x.disabled = true;
      if (!x.name.includes("DetailLedger") && x.name !== "Comment" && x.name !== "SubLedgerId" && this.hasReference && x.name !== "ReferenceId")
        x.disabled = true;
    });
  }

  public addHandler() {
    this.closeEditor();
    this.isNew = true;
    if (!this.dataList) this.dataList = [];
    this.treferenceVoucherLoded = false;
    this.setreferenceVoucherByVoucherKindList("TrsVoucherHeader/GeTreferenceVoucherByVoucherKind");
    this.rowIsEditing = true;
    let _comment: string = "";
    if (this.headerTitleToDetailTitle) _comment = this.headerTitleToDetailTitle;
    const temp = <TrsVoucherDetail>{
      Id: -1,
      RowNumber:
        this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).length > 0
          ? this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).length + 1
          : 1,
      State: RowState.New,
      Comment: _comment,
    };
    if (this.CurrentVoucherKind.ConcernInHeader === true) {
      temp.ConcernId = this.filterEntity.ConcernId;
      temp.ConcernCode = this.filterEntity.ConcernCode;
      temp.ConcernTitle = this.filterEntity.ConcernTitle;
      temp.ConcernTitle = this.filterEntity.ConcernTitle;
      temp.InvVoucherKindId = this.filterEntity.InvVoucherKindId;
      temp.IsWarehouse = this.filterEntity.IsWarehouse;
    }
    this.dataList.push(temp);
    let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
    this.editedRowIndex = this.gridData.length - 1;
    this.cd.markForCheck();
    this.setFormGroup(temp);
    if (this.grid && this.formGroup) {
      this.grid.editRow(this.editedRowIndex, this.formGroup);
    }
    const keyboardEvent = new KeyboardEvent("keydown", {
      code: "Tab",
      key: "Tab",
      keyCode: 9,
      view: window,
      bubbles: true,
    });
    document.activeElement.dispatchEvent(keyboardEvent);
  }
  isvalid(entity: TrsVoucherDetail) {
    return true;
  }
  hasdatForPaset() {
    return this.selectorService.getDataList("TrsVoucherDetail") !== undefined && (this.isAdd || this.isEdit);
  }
  copyHandler() {
    if (this.mySelection && this.mySelection.length > 0)
      this.selectorService.setDataList(
        "TrsVoucherDetail",
        this.dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached && this.mySelection.some((s) => s === x.RowNumber))
      );
    else
      this.selectorService.setDataList(
        "TrsVoucherDetail",
        this.dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached && x.RowNumber === this.editedRow.RowNumber)
      );
  }
  copyAll() {
    this.selectorService.setDataList(
      "TrsVoucherDetail",
      this.dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached)
    );
  }
  pasetHandler() {
    this.cancelHandler();
    if (this.selectorService.getDataList("TrsVoucherDetail") !== undefined) {
      this.selectorService.getDataList("TrsVoucherDetail").forEach((element) => {
        const entity = Object.assign({}, element as TrsVoucherDetail);
        entity.RowNumber = this.dataList.length + 1;
        entity.Id = 0;
        entity.State = RowState.New;
        this.dataList.push(entity);
      });
      this.setRowNumber();
      this.selectorService.setDataList("TrsVoucherDetail", undefined);
    }
  }
  public cancelHandler() {
    this.closeEditor();
  }
  setChanges() {
    this.formGroup.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x) {
        this.valueChanges.emit(x);
      }
    });
    this.fitColumns();
  }
  public saveHandler(rowIndex, formGroup): void {
    if (this.formGroup && this.formGroup?.valid && this.isvalid(this.formGroup.value)) {
      var entity = this.formGroup.value;

      if (entity.State === undefined || (entity.State === RowState.New && rowIndex === -1)) {
        entity.State = RowState.New;
        if (!this.gridData.some((x) => x.RowNumber === entity.RowNumber)) this.dataList.push(entity);
      } else if (rowIndex >= 0) {
        if (!entity.State) entity.State = this.dataList[rowIndex].State;

        if (entity.State != RowState.New) (entity as TrsVoucherDetail).State = RowState.Modify;
        if (entity.Id > 0 && this.dataList.some((x) => x.Id === entity.Id)) {
          this.dataList.forEach((m) => {
            if (m.Id === entity.Id) {
              Object.assign(m, entity);
            }
          });
        } else {
          this.dataList.forEach((m) => {
            if (m.RowNumber === entity.RowNumber && m.Id === entity.Id && m.State === entity.State) {
              if (entity.Id == -1) entity.Id = 0;
              Object.assign(m, entity);
            }
          });
        }
      }
      this.rowIsEditing = false;
      this.valueChanges.emit(entity);
      this.closeEditor();
      let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
      this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
      this.cd.markForCheck();
    } else this.sts.showDialog(`اطلاعات وارده صحیح نیست.`, "خطا", DialogType.alert);
  }
  deleteFormHelper(dataItem: any) {
    this.dataList.forEach((x) => {
      if ((dataItem.Id > 0 && x.Id === dataItem.Id) || x === dataItem) {
        if (x.State === RowState.New) x.State = RowState.Detached;
        else x.State = RowState.Delete;
      }
    });
    this.setRowNumber();
  }
  private setRowNumber() {
    let index: number = 0;
    this.gridData
      .filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached)
      .sort((a, b) => a.RowNumber - b.RowNumber)
      .forEach((x) => {
        index += 1;
        x.RowNumber = index;
      });
    this.valueChanges.emit(this.gridData[this.gridData.length - 1]);
    let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
  }
  public removeHandler({ sender, dataItem }): void {
    this.sts.showDialog(`آیا از حذف اطلاعات اطمینان دارید؟`, "حذف اطلاعات", DialogType.confirm, () => this.deleteFormHelper(dataItem));
    sender.cancelCell();
  }

  private closeEditor() {
    this.editedRow = undefined;
    this.grid.closeRow(this.editedRowIndex);
    this.rowIsEditing = false;
    this.isNew = false;
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
    this.dataList = this.dataList.filter((x) => x.Id >= 0);
    let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached && x.Id >= 0);
    this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
    this.cd.markForCheck();
  }

  private isReadOnly(field: string, dataItem: any): boolean {
    let col = this.columns.find((x) => x.name === field);
    return col && col.disabled;
  }
  public saveCurrent(): void {
    if (this.formGroup) {
      this.saveHandler(this.editedRowIndex, this.formGroup);
    }
  }
  hasMultiColumns(ColumnsName: string) {
    if (
      this.ReferenceVoucherKindId &&
      this.ReferenceVoucherKindId > 0 &&
      (!this.LookupData["TrsVoucherHeader/GeTreferenceVoucherByVoucherKind"] ||
        this.LookupData["TrsVoucherHeader/GeTreferenceVoucherByVoucherKind"].length <= 0)
    )
      this.setreferenceVoucherByVoucherKindList("TrsVoucherHeader/GeTreferenceVoucherByVoucherKind");
    if (!ColumnsName) return false;
    var columns = ColumnsName.split(",");
    return columns.length > 1;
  }
  fillCollectionsKind(ReferenceVoucherKindId: number) {
    this._httpCommonService
      .getItem<TrsVoucherKind>("TrsVoucherKind", ReferenceVoucherKindId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        this.CurrentReferenceVoucherKind = Object.assign({}, data as TrsVoucherKind);
      });
  }
  isMultiSelect(apiName: string) {
    return apiName === "TrsVoucherHeader/GeTreferenceVoucherByVoucherKind";
  }
  onRowsSelected($event, apiName: string, key: string) {
    let hasNewRecord: Boolean = false;
    if (this.grid) this.grid.focus();
    if ($event && apiName !== "TrsVoucherHeader/GeTreferenceVoucherByVoucherKind") {
      if ($event.length > 1) {
        $event.forEach((x) => {
          let entity = <TrsVoucherDetail>{};
          entity["State"] = RowState.New;
          entity[key] = x["Id"];
          entity.Id = 0;
          if (!this.dataList.some((f) => f[key] === x["Id"] && f["State"] !== RowState.Detached && f["State"] !== RowState.Delete))
            this.dataList.push(entity);
        });
        let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
        this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
        this.closeEditor();
      }
    }
    if ($event && apiName === "TrsVoucherHeader/GeTreferenceVoucherByVoucherKind") {
      $event.forEach((referenceVoucher) => {
        if (referenceVoucher && !this.gridData.some((x) => x.ReferenceId === referenceVoucher.Id)) {
          let voucherDetail: TrsVoucherDetail = <TrsVoucherDetail>{};
          voucherDetail.State = RowState.New;
          voucherDetail.RowNumber =
            this.dataList.filter((x) => x.Id >= 0 && x.State != RowState.Delete && x.State != RowState.Detached).length > 0
              ? this.dataList.filter((x) => x.Id >= 0 && x.State != RowState.Delete && x.State != RowState.Detached).length + 1
              : 1;
          //#region
          voucherDetail.Id = 0;
          voucherDetail.BankAccountId = referenceVoucher.BankAccountId;
          voucherDetail.BankAccountNo = referenceVoucher.BankAccountNo;
          voucherDetail.BankBranchTitle = referenceVoucher.BankBranchTitle;
          voucherDetail.Comment = referenceVoucher.Comment;
          voucherDetail.BankCode = referenceVoucher.BankCode;
          voucherDetail.BankId = referenceVoucher.BankId;
          voucherDetail.BankTitle = referenceVoucher.BankTitle;
          voucherDetail.BankBranchCode = referenceVoucher.BankBranchCode;
          voucherDetail.ChequeId = referenceVoucher.ChequeId;

          voucherDetail.ConcernId = referenceVoucher.ConcernId;
          voucherDetail.ConcernCode = referenceVoucher.ConcernCode;
          voucherDetail.ConcernTitle = referenceVoucher.ConcernTitle;
          voucherDetail.DetailLedgerCode = referenceVoucher.DetailLedgerCode;
          voucherDetail.DetailLedgerId = referenceVoucher.DetailLedgerId;
          voucherDetail.DetailLedgerTitle = referenceVoucher.DetailLedgerTitle;

          voucherDetail.PayerDetailLedgerId = referenceVoucher.DetailLedgerId;
          if (this.CurrentVoucherKind.OperationKindCode === 3 || this.CurrentVoucherKind.OperationKindCode === 4) {
            voucherDetail.TreasuryDetailLedger1Id = referenceVoucher.TreasuryDetailLedger1Id;
            voucherDetail.TreasuryDetailLedger2Id = referenceVoucher.TreasuryDetailLedger2Id;
            voucherDetail.TreasuryDetailLedger3Id = referenceVoucher.TreasuryDetailLedger3Id;
            voucherDetail.TreasuryDetailLedger4Id = referenceVoucher.TreasuryDetailLedger4Id;
            voucherDetail.TreasuryDetailLedger5Id = referenceVoucher.TreasuryDetailLedger5Id;
            voucherDetail.TreasuryDetailLedger6Id = referenceVoucher.TreasuryDetailLedger6Id;
            voucherDetail.TreasuryDetailLedger7Id = referenceVoucher.TreasuryDetailLedger7Id;
          } else if (this.CurrentVoucherKind.OperationKindCode === 7 && this.CurrentVoucherKind.EffectKindCode === 3) {
            voucherDetail.TreasuryDetailLedger1Id = referenceVoucher.DetailLedger1Id;
            voucherDetail.TreasuryDetailLedger2Id = referenceVoucher.DetailLedger2Id;
            voucherDetail.TreasuryDetailLedger3Id = referenceVoucher.DetailLedger3Id;
            voucherDetail.TreasuryDetailLedger4Id = referenceVoucher.DetailLedger4Id;
            voucherDetail.TreasuryDetailLedger5Id = referenceVoucher.DetailLedger5Id;
            voucherDetail.TreasuryDetailLedger6Id = referenceVoucher.DetailLedger6Id;
            voucherDetail.TreasuryDetailLedger7Id = referenceVoucher.DetailLedger7Id;
          } else if (
            (this.CurrentVoucherKind.OperationKindCode === 5 && this.CurrentVoucherKind.EffectKindCode === 2) ||
            this.CurrentVoucherKind.OperationKindCode === 6
          ) {
            voucherDetail.DetailLedger1Id = referenceVoucher.DetailLedger1Id;
            voucherDetail.DetailLedger2Id = referenceVoucher.DetailLedger2Id;
            voucherDetail.DetailLedger3Id = referenceVoucher.DetailLedger3Id;
            voucherDetail.DetailLedger4Id = referenceVoucher.DetailLedger4Id;
            voucherDetail.DetailLedger5Id = referenceVoucher.DetailLedger5Id;
            voucherDetail.DetailLedger6Id = referenceVoucher.DetailLedger6Id;
            voucherDetail.DetailLedger7Id = referenceVoucher.DetailLedger7Id;

            voucherDetail.TreasuryDetailLedger1Id = referenceVoucher.DetailLedger1Id;
            voucherDetail.TreasuryDetailLedger2Id = referenceVoucher.DetailLedger2Id;
            voucherDetail.TreasuryDetailLedger3Id = referenceVoucher.DetailLedger3Id;
            voucherDetail.TreasuryDetailLedger4Id = referenceVoucher.DetailLedger4Id;
            voucherDetail.TreasuryDetailLedger5Id = referenceVoucher.DetailLedger5Id;
            voucherDetail.TreasuryDetailLedger6Id = referenceVoucher.DetailLedger6Id;
            voucherDetail.TreasuryDetailLedger7Id = referenceVoucher.DetailLedger7Id;
          } else {
            voucherDetail.DetailLedger1Id = referenceVoucher.TreasuryDetailLedger1Id;
            voucherDetail.DetailLedger2Id = referenceVoucher.TreasuryDetailLedger2Id;
            voucherDetail.DetailLedger3Id = referenceVoucher.TreasuryDetailLedger3Id;
            voucherDetail.DetailLedger4Id = referenceVoucher.TreasuryDetailLedger4Id;
            voucherDetail.DetailLedger5Id = referenceVoucher.TreasuryDetailLedger5Id;
            voucherDetail.DetailLedger6Id = referenceVoucher.TreasuryDetailLedger6Id;
            voucherDetail.DetailLedger7Id = referenceVoucher.TreasuryDetailLedger7Id;

            voucherDetail.TreasuryDetailLedger1Id = referenceVoucher.DetailLedger1Id;
            if (!(this.CurrentVoucherKind.OperationKindCode === 5 && this.CurrentVoucherKind.EffectKindCode === 3)) {
              voucherDetail.TreasuryDetailLedger2Id = referenceVoucher.DetailLedger2Id;
              voucherDetail.TreasuryDetailLedger3Id = referenceVoucher.DetailLedger3Id;
              voucherDetail.TreasuryDetailLedger4Id = referenceVoucher.DetailLedger4Id;
              voucherDetail.TreasuryDetailLedger5Id = referenceVoucher.DetailLedger5Id;
              voucherDetail.TreasuryDetailLedger6Id = referenceVoucher.DetailLedger6Id;
              voucherDetail.TreasuryDetailLedger7Id = referenceVoucher.DetailLedger7Id;
            }
          }

          voucherDetail.ReferenceNo = referenceVoucher.VoucherNo;
          voucherDetail.DocumentDate = referenceVoucher.DocumentDate;
          voucherDetail.DocumentNo = referenceVoucher.DocumentNo;
          voucherDetail.Price = referenceVoucher.Price;
          voucherDetail.ReferenceId = referenceVoucher.Id;
          voucherDetail.Tag1 = referenceVoucher.Tag1;
          voucherDetail.Tag2 = referenceVoucher.Tag2;
          voucherDetail.Tag3 = referenceVoucher.Tag3;
          voucherDetail.Tag4 = referenceVoucher.Tag4;
          voucherDetail.Tag5 = referenceVoucher.Tag5;
          voucherDetail.Tag6 = referenceVoucher.Tag6;
          voucherDetail.TreasuryDetailLedgerId = referenceVoucher.DetailLedgerId;
          voucherDetail.TreasuryDetailLedgerCode = referenceVoucher.DetailLedgerCode;
          voucherDetail.TreasuryDetailLedgerTitle = referenceVoucher.DetailLedgerTitle;

          if (!voucherDetail.DiscountRate) voucherDetail.DiscountRate = this.DefaultValues["DiscountRate"];
          if (!voucherDetail.DiscountAmount) voucherDetail.DiscountAmount = this.DefaultValues["DiscountAmount"];
          //#endregion
          if (!this.dataList.some((f) => f[key] === referenceVoucher["Id"] && f["State"] !== RowState.Detached && f["State"] !== RowState.Delete)) {
            this.dataList.push(voucherDetail);
            hasNewRecord = true;
          }
        }
      });
      if (this.dataList.length > 0) this.valueChanges.emit(this.dataList[this.dataList.length - 1]);
      let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
      this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
      if (hasNewRecord) this.closeEditor();
    }
    this.valueChanges.emit(this.dataList[0]);
  }

  setreferenceVoucherByVoucherKindList(apiName: string) {
    if (!this.isLOading && !this.treferenceVoucherLoded) {
      if (this.dataList && this.dataList.some((x) => x.Id > 0)) this.filterEntity.Id = this.dataList.find((x) => x.Id > 0).TrsVoucherHeaderId;
      this.isLOading = true;
      let VoucherKindIds: number[] = this.dataList
        ? this.dataList.filter((x) => x.ReferenceId && x.State !== RowState.Delete && x.State !== RowState.Detached).map((x) => x.ReferenceId)
        : [];

      this._httpCommonService
        .create(apiName, this.filterEntity)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.isLOading = false;
            x = (x as TrsVoucherDetail[]).filter((f) => !VoucherKindIds.some((r) => r === f.Id));
            if (apiName === "TrsVoucherHeader/GeTreferenceVoucherByVoucherKind") {
              this.selectorService.setDataList("ReferenceId", x as []);
              this.treferenceVoucherLoded = true;
            } else this.LookupData[apiName] = x;
          },
          (error) => (this.isLOading = false)
        );
    }
  }
  setDropdownlist(apiName: string, systemName: string, category: string) {
    if (apiName === "TrsVoucherHeader/GeTreferenceVoucherByVoucherKind" && this.ReferenceVoucherKindId && this.ReferenceVoucherKindId > 0) {
      this.treferenceVoucherLoded = false;
      this.setreferenceVoucherByVoucherKindList(apiName);
    }

    if (systemName && category && !this.loadingData) {
      this.lookupservice
        .getLookupbyCategory(systemName, category)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.LookupData[apiName] = x;
        });
    } else
      this._httpCommonService
        .getList(apiName)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            if (apiName.includes("Concern")) {
              let vk = (x as any[]).filter((c) => this.CurrentVoucherKind.TrsVoucherKindConcerns.some((vk) => vk.TrsConcernId === c.Id));
              this.LookupData[apiName] = vk;
            } else this.LookupData[apiName] = x;
          },
          (error) => {
            console.log(error);
          }
        );
  }
  getItemDisplayById(apiName: string, systemName: string, id: number, displayMember, valueMember: string, dataItem: any, columnName: string) {
    if (!id) return "";
    if (apiName === "TrsVoucherHeader/GeTreferenceVoucherByVoucherKind") {
      if (dataItem["ReferenceNo"]) return dataItem["ReferenceNo"];
      else return "";
    }
    if (apiName.includes("Concern")) return dataItem[`Concern${displayMember}`];
    if (apiName.includes("SubLedger")) return dataItem[`SubLedger${displayMember}`];
    if (columnName == "BankId") return dataItem[`Bank${displayMember}`];
    if (columnName === "BankAccountId") return dataItem[`BankAccountNo`];
    if (columnName === "ChequeId") return dataItem[`DocumentNo`];
    if (columnName.includes("DetailLedger")) {
      columnName = columnName.replace("Id", "");
      return dataItem[`${columnName}${displayMember}`];
    }

    // if (dataItem[`Goods${displayMember}`])
    //   return dataItem[`Goods${displayMember}`];
    // else
    return "";
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.selectorService.setDataList("TrsVoucherDetail", undefined);
    this.selectorService.setDataList("ReferenceId", undefined);
    this.selectorService.setDataList("BankAccountId", undefined);
    this.saveGridColumnInfo();
    this.LookupData = undefined;
    this.DefaultValues = undefined;
    this.grid = undefined;
    this.currentLookup = undefined;
    this.mySelection = undefined;
    this.columns = undefined;
    this._filterEntity = undefined;
    this.CurrentVoucherKind = undefined;
    this.formGroup = undefined;
    this._dataList = undefined;
    this.gridData = undefined;
    this.CurrentReferenceVoucherKind = undefined;
    this.editedRow = undefined;
  }
  setValue(key: string, value: any) {
    if (!this.formGroup.controls[key]) this.formGroup.addControl(key, new UntypedFormControl(value));
    else this.formGroup.controls[key].setValue(value);
  }
  selectionChange(event: any, apiName: string, columnName: string) {
    if (this.grid) this.grid.focus();
    if (apiName === "TrsVoucherHeader/GeTreferenceVoucherByVoucherKind") {
      this.onRowsSelected([event], apiName, "");
      return;
    }
    this.currentLookup = event;
    if (this.formGroup) this.formGroup.updateValueAndValidity();

    this.valueChanges.emit(event);
    if (event && columnName === "SubLedgerId") {
      if (this.formGroup) {
        this.setValue("SubLedgerTitle", event.Title);
        this.setValue("SubLedgerCode", event.Code);
      }
    }
    if (event && columnName === "DetailLedgerId") {
      if (this.formGroup) {
        this.setValue("DetailLedgerId", event.Id);
        this.setValue("DetailLedgerTitle", event.Title);
        this.setValue("DetailLedgerCode", event.Code);
      }
    }
    if (event && columnName === "DetailLedger1Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger1Title", event.Title);
        this.setValue("DetailLedger1Code", event.Code);
      }
    }
    if (event && columnName === "DetailLedger2Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger2Title", event.Title);
        this.setValue("DetailLedger2Code", event.Code);
      }
    }
    if (event && columnName === "DetailLedger3Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger3Title", event.Title);
        this.setValue("DetailLedger3Code", event.Code);
      }
    }
    if (event && columnName === "DetailLedger4Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger4Title", event.Title);
        this.setValue("DetailLedger4Code", event.Code);
      }
    }
    if (event && columnName === "DetailLedger5Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger5Title", event.Title);
        this.setValue("DetailLedger5Code", event.Code);
      }
    }
    if (event && columnName === "DetailLedger6Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger6Title", event.Title);
        this.setValue("DetailLedger6Code", event.Code);
      }
    }
    if (event && columnName === "DetailLedger7Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger7Title", event.Title);
        this.setValue("DetailLedger7Code", event.Code);
      }
    }
    if (event && columnName === "TreasuryDetailLedgerId") {
      if (this.formGroup) {
        this.setValue("TreasuryDetailLedgerTitle", event.Title);
        this.setValue("TreasuryDetailLedgerCode", event.Code);
      }
    }
    if (event && columnName === "TreasuryDetailLedger1Id") {
      if (this.formGroup) {
        this.setValue("TreasuryDetailLedger1Title", event.Title);
        this.setValue("TreasuryDetailLedger1Code", event.Code);
      }
    }
    if (event && columnName === "TreasuryDetailLedger2Id") {
      if (this.formGroup) {
        this.setValue("TreasuryDetailLedger2Title", event.Title);
        this.setValue("TreasuryDetailLedger2Code", event.Code);
      }
    }
    if (event && columnName === "TreasuryDetailLedger3Id") {
      if (this.formGroup) {
        this.setValue("TreasuryDetailLedger3Title", event.Title);
        this.setValue("TreasuryDetailLedger3Code", event.Code);
      }
    }
    if (event && columnName === "TreasuryDetailLedger4Id") {
      if (this.formGroup) {
        this.setValue("TreasuryDetailLedger4Title", event.Title);
        this.setValue("TreasuryDetailLedger4Code", event.Code);
      }
    }
    if (event && columnName === "TreasuryDetailLedger5Id") {
      if (this.formGroup) {
        this.setValue("TreasuryDetailLedger5Title", event.Title);
        this.setValue("TreasuryDetailLedger5Code", event.Code);
      }
    }
    if (event && columnName === "TreasuryDetailLedger6Id") {
      if (this.formGroup) {
        this.setValue("TreasuryDetailLedger6Title", event.Title);
        this.setValue("TreasuryDetailLedger6Code", event.Code);
      }
    }
    if (event && columnName === "TreasuryDetailLedger7Id") {
      if (this.formGroup) {
        this.setValue("TreasuryDetailLedger7Title", event.Title);
        this.setValue("TreasuryDetailLedger7Code", event.Code);
      }
    }
    if (event && columnName === "ConcernId") {
      if (this.formGroup) {
        this.setValue("ConcernTitle", event.Title);
        this.setValue("ConcernCode", event.Code);
        this.setValue("InvVoucherId", event.InvVoucherId);
        this.setValue("IsWarehouse", event.IsWarehouse);
      }
    }
    if (event && columnName === "BankId") {
      if (this.formGroup) {
        // if (this.formGroup.get("BankCode").value !== event.Code) {
        //   this.setValue("BankAccountId", undefined);
        //   if (this.formGroup && this.CurrentVoucherKind.OperationKindCode === 2) {
        //     this.setValue("BankAccountNo", undefined);
        //     // this.setValue("BankBranchCode", undefined);
        //     // this.setValue("BankBranchTitle", undefined);
        //     this.setValue("ChequeId", undefined);
        //     this.setValue("DocumentNo", undefined);
        //   }
        // }
        this.setValue("BankTitle", event.Title);
        this.setValue("BankCode", event.Code);
        this.setBankAccountDataList(event.Id);
      }
      this.dataReadedColumns = "";
    }
    if (event && columnName === "BankAccountId") {
      this.setChequeDataList(event.Id);
      if (this.formGroup && this.CurrentVoucherKind.OperationKindCode === 2) {
        this.setValue("BankAccountNo", event.Code);
        this.setValue("BankBranchCode", event.BankBranchCode);
        this.setValue("BankBranchTitle", event.BankBranchTitle);
      }
    }
    if (event && columnName === "ChequeId") {
      if (this.formGroup) {
        this.setValue("DocumentNo", event.DocumentNo);
      }
    }
    if (event && columnName === "TreasuryDetailLedgerId") {

      if (this.formGroup) {
        this._httpCommonService
        .getList(`BankAccount/ReadBankAccountLookUp`)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x:any[]) => {
          const finditem = x.find(f=>f.DetailLedgerId === event.Id);
          this.setValue("BankAccountId", finditem?.Id);
          this.setValue("BankAccountNo",  finditem?.Code);
          this.setValue("BankBranchCode",  finditem?.BankBranchCode);
          this.setValue("BankBranchTitle",  finditem?.BankBranchTitle);
        });

      }
    }
    if (this.formGroup) this.formGroup.updateValueAndValidity();
  }

  setBankAccountDataList(Id: number) {
    this._httpCommonService
      .getList(`BankAccount/ReadBankAccountLookUp/${Id}`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        this.selectorService.setDataList("BankAccountId", x as []);
      });
  }

  setChequeDataList(Id: number) {
    let ChequeId = this.formGroup && this.formGroup.get("ChequeId").value ? this.formGroup.get("ChequeId").value : 0;
    this._httpCommonService
      .getList(`ChequeBookHeader/GetByBankAccount/${Id}/${ChequeId}`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        let cheqIds: number[] = [];
        let Id = this.formGroup && this.formGroup.get("Id").value ? this.formGroup.get("Id").value : -2;
        this.dataList
          .filter((ci) => ci.ChequeId && ci.Id !== Id)
          .forEach((ci) => {
            if (!cheqIds.some((chid) => chid === ci.ChequeId)) cheqIds.push(ci.ChequeId);
          });
        if (x) x = (x as ChequeBookDetail[]).filter((ci) => !cheqIds.some((cid) => cid === ci.Id));
        this.LookupData["ChequeBookHeader/GetByBankAccount"] = (x as ChequeBookDetail[]).sort((a, b) => a.DocumentNo - b.DocumentNo);
      });
  }
  getDateValue(date: Date) {
    if (!date) return "";
    let m: Moment = moment(date.toString()).locale("fa");
    return m.format("YYYY/MM/DD");
  }
  getColumnSum(columnName: string) {
    return this.dataList?.getSumWithKey(columnName);
  }
  getFilters(columnsName: string, searchValue: string, skip: number, take: number) {
    var filters: GridFilter[] = [];
    const columns = columnsName.split(",");
    columns.forEach((x) => {
      {
        if (x === "Id" && isNumber(searchValue))
          filters.push({ Filed: x, Operator: "eq", Type: "F", Skip: skip, Take: take, Value: Number(searchValue), Logic: "or" });
        else filters.push({ Filed: x, Operator: "contains", Type: "F", Skip: skip, Take: take, Value: searchValue, Logic: "or" });
      }
    });
    return filters;
  }
  isDetailLedgerKind(columnName: string) {
    return columnName === "DetailLedgerId" || columnName === "TreasuryDetailLedgerId";
  }
  shouldBeChangedData(columnName: string): boolean {
    return !this.dataReadedColumns.includes(columnName);
  }
  onDataStateChange(columnName: string, searchValue: string, skip: number, take: number): Observable<PagingDataResult<DetailLedger>> {
    var abs = new BehaviorSubject<PagingDataResult<DetailLedger>>(null);
    const dLkids: number[] = [];
    if (
      columnName === "DetailLedgerId" &&
      this.CurrentVoucherKind.TrsVoucherKindDetailLedgerKinds &&
      this.CurrentVoucherKind.TrsVoucherKindDetailLedgerKinds.length > 0
    ) {
      this.CurrentVoucherKind.TrsVoucherKindDetailLedgerKinds.forEach((x) => dLkids.push(x.DetailLedgerKindId));
    }
    if (
      columnName === "TreasuryDetailLedgerId" &&
      this.CurrentVoucherKind.TrsVoucherKindTreasuryDetailLedgerKinds &&
      this.CurrentVoucherKind.TrsVoucherKindTreasuryDetailLedgerKinds.length > 0
    ) {
      this.CurrentVoucherKind.TrsVoucherKindTreasuryDetailLedgerKinds.forEach((x) => dLkids.push(x.DetailLedgerKindId));
    }
    let apiName: string = "DetailLedger/DetailLedgerWithDetailLedgerKindIds";
    const filter = this.getFilters("Id,Code,Title", searchValue, skip, take);
    if (dLkids && dLkids.length > 0)
      filter.push({ Filed: "dLkinds", Operator: "eq", Value: dLkids, Type: "F", Skip: skip, Take: take, Logic: "and" });
    this._httpCommonService
      .GetFilterGrid<PagingDataResult<DetailLedger>>(apiName, filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: PagingDataResult<DetailLedger>) => {
        if (x) abs.next(x);
        if (!this.dataReadedColumns.includes(columnName)) this.dataReadedColumns = this.dataReadedColumns + "," + columnName;
      });
    return abs.asObservable();
  }
  setColumnInfo(columnInfos: GridColumnInfoDetail[]) {
    if (!this.grid)
      setTimeout(() => {
        this.setColumnInfo(columnInfos);
      }, 50);

    if (this.grid?.columns) {
      if (this.grid.columns.length <= 1) {
        setTimeout(() => this.setColumnInfo(columnInfos), 200);
      }
    }
    if (this.grid?.columns) {
      this.grid.columns.forEach((x: ColumnComponent) => {
        const column = columnInfos.find((c) => c.name === (x.field ?? x.title));
        if (column) {
          x.leafIndex = column.leaftindex;
          x.orderIndex = column.orderindex;
          x.minResizableWidth = column.minResizableWidth;
          x.width = column.width;
          x.hidden = column.hidden;
        }
      });
    }
    this.isFirstLoad = true;
    this.cd.detectChanges();
    setTimeout(() => {
      const firstCol: ScrollRequest = {};
      firstCol.column = 0;
      if (this.grid && firstCol) this.grid?.scrollTo(firstCol);
    }, 110);
  }
  setDefaultColumnInfo() {
    this.grid?.columns?.forEach((x: ColumnComponent) => {
      if (x.title === "عملیات") {
        x.width = 70;
        x.minResizableWidth = 60;
        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
      if (!x.title && !x.field) {
        x.width = x.width;
        x.minResizableWidth = x.minResizableWidth;
        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
      const column = this.columns.find((c) => c.name === (x.field ?? x.title));
      if (column) {
        x.width = column.columnWidth;
        x.minResizableWidth = x.minResizableWidth;
        x.hidden = !column.listVisible;

        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
    });
    this.cd.markForCheck();
  }
  async saveGridColumnInfo() {
    const list: GridColumnInfoDetail[] = [];
    if (this.grid && this.grid.columns) {
      this.grid.columns.forEach((x: ColumnComponent) => {
        if (x) {
          const column = new GridColumnInfoDetail();
          column.leaftindex = x.leafIndex;
          column.orderindex = x.orderIndex;
          column.hidden = x.hidden;
          column.name = x.field ?? x.title;
          column.width = x.width;
          column.minResizableWidth = x.minResizableWidth;
          column.title = x.title;
          list.push(column);
        }
      });
      if (!this._GridColumnInfo) this._GridColumnInfo = new GridColumnInfo();
      this._GridColumnInfo.Key = this.CurrentVoucherKind?.Id ? `TrsVoucherDetail_${this.CurrentVoucherKind?.Id}` : "TrsVoucherDetail";
      this._GridColumnInfo.ColumnInfo = JSON.stringify(list);
      this._GridColumnInfo.CreatedUserId = this.accountService.authService.currentUser.Id;
      if (this.state.group && this.state.group.length > 0) this._GridColumnInfo.Group = JSON.stringify(this.state.group);
      else this._GridColumnInfo.Group = undefined;
      await this._httpCommonService.updateItem("MisSetUp/UpdateGridColumnInfo", this._GridColumnInfo).pipe(takeUntil(this.ngUnsubscribe)).toPromise();
    }
  }
  async fitColumns() {
    if (!this.isFirstLoad) {
      if (this._GridColumnInfo) {
        let columnInfos: GridColumnInfoDetail[] = JSON.parse(this._GridColumnInfo.ColumnInfo);
        this.setColumnInfo(columnInfos);
      } else {
        const x = await this._httpCommonService
          .get(
            "MisSetUp/GetGridColumnInfo/?key=" +
              (this.CurrentVoucherKind?.Id ? `TRsVoucherDetail_${this.CurrentVoucherKind.Id}` : "TrsVoucherDetail") +
              `&CreatedUserId=${this.accountService.authService.currentUser.Id}`
          )
          .pipe(takeUntil(this.ngUnsubscribe))
          .toPromise();
        if (x) {
          this._GridColumnInfo = x as GridColumnInfo;
          this.setColumnInfo(JSON.parse(x["ColumnInfo"]));
          if (this._GridColumnInfo.Group) {
            this.state.group = JSON.parse(x["Group"]);
          }
        } else this.setDefaultColumnInfo();

        this.isFirstLoad = true;
      }
    }
    setTimeout(
      () => {
        this.cd.detectChanges();
        this.cd.markForCheck();
      },
      this.isFirstLoad ? 500 : 200
    );

    this.cd.markForCheck();
  }
  public cellCloseHandler(args: any) {
    const { formGroup, dataItem } = args;
    if (formGroup && !formGroup.valid) {
      return;
    } else if (formGroup && formGroup.dirty) {
      this.saveCurrent();
    } else this.closeEditor();
  }
  public editHandler({ sender, rowIndex, dataItem }) {
    this.editedRow = undefined;
    if (this.editedRowIndex !== undefined && this.editedRowIndex >= 0 && this.editedRowIndex !== rowIndex)
      this.cellCloseHandler({ formGroup: this.formGroup, dataItem: dataItem });
    if (this.rowIsEditing) return;
    if (dataItem) this.valueChanges.emit(dataItem);
    if (!this.isAdd && !this.isEdit) {
      this.valueChanges.emit(dataItem);
      return;
    }
    this.setFormGroup(dataItem);

    this.rowIsEditing = true;
    this.editedRowIndex = rowIndex;
    this.valueChanges.emit(dataItem);
    if (this.grid) this.grid.editRow(rowIndex, this.formGroup);
    Object.keys(this.formGroup.controls).forEach((key) => {
      if (this.formGroup.controls[key].invalid) {
        console.log(key);
        this.setValue(key, 0);
      }
    });
    setTimeout(() => {
      if (this.grid) this.grid.focus();
      this.cd.markForCheck();
      if (this.formGroup) this.formGroup.updateValueAndValidity();
    }, 500);
  }
  public onUserRowSelect({ sender, column, rowIndex, columnIndex, dataItem }): void {
    this.editedRow = dataItem;
    this.valueChanges.emit(this.editedRow);
  }
  public doubleclic(args: any) {
    this.editedRow = undefined;
    if (this.editedRowIndex !== undefined && this.editedRowIndex >= 0 && this.editedRowIndex !== this.grid.activeRow.index - 1)
      this.cellCloseHandler({ formGroup: this.formGroup, dataItem: this.grid.activeRow.dataItem });
    this.editHandler({ sender: this.grid, rowIndex: this.grid.activeRow.index - 1, dataItem: this.grid.activeRow.dataItem });
  }
  onKeyup($event) {
    if ($event.key === "Escape") {
      this.cd.markForCheck();
      this.formGroup.updateValueAndValidity();
      if (!(this.formGroup && (this.formGroup.touched || this.formGroup.dirty))) this.cancelHandler();
    }
  }
}
